require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./science-et-ingnierie-computationnelles-2-2-2-7.json") })
        }
      }, "path---science-et-ingnierie-computationnelles-2-2-2-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---science-et-ingnierie-computationnelles-2-2-2-7!./.cache/json/science-et-ingnierie-computationnelles-2-2-2-7.json
// module id = 559
// module chunks = 231608221292675